module.exports = __webpack_public_path__ + "assets/images/template/sample-image.png?v=0c8e143c";